var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import useStyle from './style';
const CheckableTag = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, style, className, checked, children, icon, onChange, onClick } = props, restProps = __rest(props, ["prefixCls", "style", "className", "checked", "children", "icon", "onChange", "onClick"]);
    const { getPrefixCls, tag } = React.useContext(ConfigContext);
    const handleClick = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = useStyle(prefixCls);
    const cls = classNames(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked,
    }, tag === null || tag === void 0 ? void 0 : tag.className, className, hashId, cssVarCls);
    return wrapCSSVar(React.createElement("span", Object.assign({}, restProps, { ref: ref, style: Object.assign(Object.assign({}, style), tag === null || tag === void 0 ? void 0 : tag.style), className: cls, onClick: handleClick }),
        icon,
        React.createElement("span", null, children)));
});
export default CheckableTag;
